.wrapper {
  display: flex;
  flex: 1;
  align-items: center;
  font-family: 'Aeroport';
  padding: .7rem 0;
}

.avatar {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 1rem 0 0;
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 50%;
  border: solid 1px var(--gray-alt);
  font-size: .9rem;
}

.nameWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
}

.name {
  font-size: 1rem;
}

.email {
  font-size: .8rem;
}

.addButton {
  height: 26px;
  width: 26px;
  border-radius: 26px;
  background-color: #000000;
  text-align: center;
  margin-right: 1rem;
}

.addIcon {
  font-size: 21px;
  color: white;
  font-weight: 200;
  line-height: 21px;
}
